import { isContactToScheduleApplyEnabled } from '@/service/parentContacts/isContactToScheduleApplyEnabled';
import { getContactToScheduleApplyEligibility } from '@/service/parentContacts/getContactToScheduleApplyEligibility';

angular.module('inspinia').factory('parentContactsService', function () {
  return {
    isContactToScheduleApplyEnabled,
    // 連絡即予定反映の前提条件を満たすかを判定APIに問い合わせる。
    // 失敗（HTTP エラー・通信エラー・入力の不正）は、前提条件を満たさない（false）と区別できるよう reject する。
    getContactToScheduleApplyEligibility,
  };
});
